export default `
  mutation deleteBCObject($workflowId: String!, $id: ID!) {
    deleteBCObject(workflowId: $workflowId, id: $id) {
      id
    }
  }
`
